import React from "react";

const DEFAULT_REGEX = /\d+/g;

/**
 * Takes a string and adds <span></span> tags around any sequence of RegExp
 * @param {string} message String to add <span></span> tags, can be a number
 * @param {RegExp} regex Regular expression to match any sequence, defaults to /\d+/g (numbers)
 * @returns {string} String with <span></span> tags around any sequence of RegExp
 */
function addSpanToText(message, regex = DEFAULT_REGEX) {
  const str = message.toString();

  // * Split the string into an array of substrings
  const substrings = str.split(regex);

  // * Use match() to get an array of all the matched substrings (numbers)
  const numbers = str.match(regex);

  // * Map over the substrings array and add <span></span> tags around the corresponding numbers
  const result = substrings.map((substring, index) => {
    if (numbers && numbers[index]) {
      return (
        <React.Fragment key={index}>
          {substring}
          <span className="c-table-numbered-text">{numbers[index]}</span>
        </React.Fragment>
      );
    } else {
      return substring;
    }
  });

  // * Join the array of substrings back into a string
  return <>{result}</>;
}

export default addSpanToText;
